<template>
  <div>
    <topbar />
    <div class="container is-fluid">
      <div class="breadcrumbs">
        <breadcrumbs />
      </div>
      <router-view />
    </div>
  </div>
</template>
<script>
  import topbar from './topbar.vue';
  import breadcrumbs from './breadcrumbs.vue';

  export default {
    name: 'home',
    components: { topbar, breadcrumbs }
  }
</script>
<style scoped>
  .breadcrumbs {
    margin-top:1.6rem;
    margin-bottom:1rem;
  }
</style>



// WEBPACK FOOTER //
// front/src/components/home.vue